import React from 'react';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';

import { displaysActions } from '~/renderer/store/displays';
import { isRenderProcess } from '~/renderer/utils';

export const useResizeCFD = () => {
  const dispatch = useDispatch();
  const onResize = debounce(() => {
    dispatch(
      displaysActions.updateSelectedDisplay({
        id: 1,
        size: { width: document.body.clientWidth, height: document.body.clientHeight },
      }),
    );
  }, 2000);

  React.useEffect(() => {
    if (isRenderProcess) return;
    onResize();

    // As the Browser CFD window is expanded to another screen it will send its size
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
